import { routes } from "../../../constants";
import { baseRouteMaker } from "../../../constants/routeConsts";
import { t } from "i18next";

export const useAppointmentsMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemCalendar */
  const menuItemCalendar = {
    id: "calendar",
    title: t("tabs.calender"),
    url: baseRouteMaker(routes.CALENDAR),
  };
  tempMenuGroup.push(menuItemCalendar);
  /* menuItemCalendar */

  /* menuItemAppointmentsInfo */
  const menuItemAppointmentsInfo = {
    id: "appointments-info",
    title: t("tabs.appointmentInfo"),
    url: baseRouteMaker(routes.APPOINTMENTS_INFO),
  };
  tempMenuGroup.push(menuItemAppointmentsInfo);
  /* menuItemAppointmentsInfo */

  return tempMenuGroup;
};
